import PositionIcon from "@mui/icons-material/People";
import ListPositions from "./List";
import { POSITIONS, EmployeeServicePath } from "utils/constants";
import CreatePositions from "./Create";
import EditPositions from "./Edit";
import ShowPositions from "./Show";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  // TODO - employees
  isMenu: true,
  tenancies: [tenants.MU, tenants.MGU, tenants.SU],
  icon: <PositionIcon />,
  name: EmployeeServicePath + POSITIONS,
  title: "Позиции",
  list: <ListPositions />,
  create: <CreatePositions />,
  createPermission: permissions.canCreateEmployeePositions,
  edit: <EditPositions />,
  editPermission: permissions.canUpdateEmployeePositions,
  show: <ShowPositions />,
  showPermission: permissions.canPreviewEmployeePositions,
  permission: permissions.canPreviewEmployeePositions,
};
